import React from 'react'
import './BCSupplierCard.scss'
import VisitWebIcon from './visit_website_icon.svg'
import Clock from './clock.svg'
import Pills from './pills.svg'
import StickyNotes from './sticky_notes.svg'
import VisitWebIconWhite from './open_website_icon_white.svg'
import { SingleService } from './SingleService.jsx'

const locale = document.documentElement.lang || 'en'

const capitalizeFirstLetterOfWord = (word) => {
  return word.charAt(0).toUpperCase() + word.slice(1)
}

export const availableServicesString = (supplier, bcavailable) => {
  const bcAvailableArrayWithUndefined = Object.keys(bcavailable).map((key) => {
    if (supplier[key]) {
      return bcavailable[key]
    }
    return undefined
  })

  const bcAvailableArray = bcAvailableArrayWithUndefined.filter((element) => {
    return element !== undefined
  })

  let bcAvailableFinalString = null

  if (bcAvailableArray.length > 0) {
    bcAvailableArray[0] = capitalizeFirstLetterOfWord(bcAvailableArray[0])
    bcAvailableFinalString = bcAvailableArray.join(', ')
  }

  return bcAvailableFinalString
}

const BCSupplierCard = ({ supplier, lexicon }) => {
  const bcavailable = {
    has_emergency_contraception: lexicon.get('emergency_contraception'),
    has_pill: lexicon.get('birth_control_pill'),
    has_patch: lexicon.get('birth_control_patch'),
    has_ring: lexicon.get('birth_control_ring'),
    has_shot: lexicon.get('birth_control_shot'),
  }

  let notes = supplier.public_notes_en
  if (locale === 'es' && supplier.public_notes_es) {
    notes = supplier.public_notes_es
  }

  return (
    <div className="BCSupplierCard">
      <div className="provider-name">{supplier.name}</div>

      <a
        className="website no-external-link-styling"
        href={supplier.url}
        target="_blank"
        rel="noreferrer"
      >
        <div className="icon">
          {VisitWebIcon && <img src={VisitWebIcon} alt="visit website" />}
        </div>
        <div>{lexicon.get('website')}</div>
      </a>
      <div className="section-divide">
        <div>{lexicon.get('service')}</div>
        <div className="thin-gray-line" />
      </div>
      <div className="services">
        {availableServicesString(supplier, bcavailable) && (
          <SingleService
            name={lexicon.get('birth_control_available')}
            details={availableServicesString(supplier, bcavailable)}
            icon={Pills}
          />
        )}

        <SingleService
          name={lexicon.get('delivery_time')}
          details={supplier.delivery_time_en}
          icon={Clock}
        />

        <SingleService
          name={lexicon.get('notes')}
          details={notes}
          icon={StickyNotes}
        />
      </div>
      <a
        className="view-details no-external-link-styling"
        href={supplier.url}
        target="_blank"
        rel="noreferrer"
      >
        {lexicon.get('details')}
        <img src={VisitWebIconWhite} alt="visit website" />
      </a>
    </div>
  )
}

export default BCSupplierCard
